import type { I18nT } from '@runtime/core/i18n/i18n'
import { svgPoster } from '@runtime/core/theme/posterThemes'
import type { ThemeIndexItem } from '@runtime/features/poster/logic/posterTheme.types'

import styles from '@runtime/features/poster/components/PosterThemeCard.module.scss'

type PosterThemeCardProps = {
  item: ThemeIndexItem
  selected: boolean
  loaded: boolean
  showPrivateBadge: boolean
  t: I18nT
  markLoaded: (id: string) => void
  onPick: (item: ThemeIndexItem) => void
}

export default function PosterThemeCard({
  item,
  selected,
  loaded,
  showPrivateBadge,
  t,
  markLoaded,
  onPick,
}: PosterThemeCardProps) {
  return (
    <button
      type="button"
      className={styles.card}
      data-testid="poster-card"
      aria-label={t('posterModal.applyTheme', { name: item.name })}
      aria-pressed={selected}
      title={item.name}
      onClick={() => onPick(item)}
    >
      <div className={styles.preview} data-loaded={loaded ? 'true' : 'false'}>
        {selected ? (
          <span
            className={styles.selectedBadge}
            data-testid="poster-selected-badge"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="m3 8 3 3 7-7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {t('posterModal.selected')}
          </span>
        ) : null}
        {showPrivateBadge ? (
          <span className={styles.privateBadge}>
            {t('posterModal.privateBadge')}
          </span>
        ) : null}
        {!loaded ? <div className={styles.spinner} aria-hidden="true" /> : null}
        <img
          alt={t('posterModal.previewAlt', { name: item.name })}
          src={item.preview || undefined}
          loading="lazy"
          onLoad={() => markLoaded(item.id)}
          onError={(event) => {
            try {
              event.currentTarget.src = svgPoster(item.name)
            } catch {
              // ignore
            }
            markLoaded(item.id)
          }}
        />
      </div>
      <div className={styles.title}>{item.name}</div>
    </button>
  )
}
